var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4924 5.02348C18.4924 5.02348 14.6119 0.424072 9.3291 0.424072C4.04663 0.424072 0.165808 5.02348 0.165808 5.02348C-0.0552692 5.28549 -0.0552692 5.71448 0.165808 5.97676C0.165808 5.97633 4.04663 10.5758 9.3291 10.5758C14.6116 10.5758 18.492 5.9764 18.492 5.9764C18.7135 5.71439 18.7135 5.28554 18.4923 5.02356L18.4924 5.02348ZM9.3291 9.40717C7.1713 9.40717 5.42181 7.65798 5.42181 5.49988C5.42181 3.34179 7.17144 1.5926 9.3291 1.5926C11.4868 1.5926 13.2364 3.34223 13.2364 5.49988C13.2364 7.65754 11.4872 9.40717 9.3291 9.40717Z",
    fill: "#1D1D1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1718 4.68232C10.7128 4.68232 10.3403 4.31012 10.3403 3.85083C10.3403 3.73087 10.3659 3.61672 10.4117 3.5139C10.0901 3.33815 9.72113 3.23816 9.32898 3.23816C8.08001 3.23816 7.06738 4.25078 7.06738 5.49976C7.06738 6.74874 8.08001 7.76165 9.32898 7.76165C10.578 7.76165 11.5906 6.74903 11.5906 5.50005C11.5906 5.19711 11.5307 4.90807 11.4225 4.6438C11.3435 4.66858 11.259 4.68232 11.1718 4.68232Z",
    fill: "#1D1D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.328e79be2be33c296e901691c4bd54af.svg";
export { ForwardRef as ReactComponent };